export const division = {
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar esta división?",
        "description": "",
        "error": "Ocurrió un error al eliminar la división",
        "success": "La división se eliminó exitosamente"
      }
    },
    "snackbar": {
      "create": {
        "success": "La división se creó exitosamente",
        "error": "Ocurrió un error al crear la división"
      },
      "update": {
        "success": "La división se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar la división"
      },
      "delete": {
        "success": "La división se eliminó exitosamente",
        "error": "Ocurrió un error al eliminar la división"
      }
    },
    "filter": {
      "title": "Divisiones",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar división",
        "firstSelect": "Estatus de la división",
        "rol": "Rol"
      }
    },
    "informationCard": {
      "create": {
        "title": "Nueva división"
      },
      "edit": {
        "title": "Editar división"
      },
      "buttons": {
        "add": "Agregar división",
        "cancel": "Cancelar",
        "edit": "Actualizar división"
      }
    }
  }